<div id="header" class="pt-38px pb-24px desktop">
  <div class="container-12 pr-36px pl-36px">
    <div class="row">
      <div class="col">
        <img class="logo-img link" src="../../../assets/img/logo_go_contratos.png">
      </div>
      <div class="col-5">
        <div class="row">
          <div class="col center" *ngFor="let leng of lengragueList">
            <span class="blue-link f-20" (click)="setLanguage(leng.value)">{{leng.label}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div  class="mobile">
  <div class="container-12">
    <div class="row">
      <div class="col">
          <div class="p-2">
              <i class="f-26 fas fa-bars"></i>
          </div>
      </div>
      <div class="col right">
          <div class="d-flex flex-row-reverse">
              <div class="box-shadow-flag p-2">
                  <div *ngIf="language == 'pt_BR'" (click)="setLanguage('en_US')">
                      <img src="../../../assets/img/arrow_down.png" />
                      <img class="pl-2" src="../../../assets/img/flag_brazil.png" />
                  </div>
                  <div *ngIf="language == 'en_US'" (click)="setLanguage('pt_BR')">
                      <img src="../../../assets/img/arrow_down.png" />
                      <img class="pl-2" src="../../../assets/img/flag_usa.png" />
                  </div>
              </div>
          </div>
      </div>
  </div>
  </div>
</div>